import React from 'react';
import { BlowOut, Delay, Miscollection } from '../modules/abnormalities';
import { ABNORMALITIES } from '../constants';
import Generic from '../modules/abnormalities/containers/Generic';

class AbnormalityTypesRouteHandler extends React.Component {
    render() {
        const { params, route: { manifestBased } } = this.props;

        switch (params.type) {
            case ABNORMALITIES.BLOWOUT:
                return (
                    <BlowOut
                        runId={params.id}
                        abnormalityId={params.abnormalityId}
                        abnormalityType={params.type}
                    />
                );
            case ABNORMALITIES.DELAY:
                return (
                    <Delay
                        runId={params.id}
                        abnormalityId={params.abnormalityId}
                        abnormalityType={params.type}
                    />
                );
            case ABNORMALITIES.DAMAGE:
            case ABNORMALITIES.EARLY_FREIGHT:
            case ABNORMALITIES.GENERIC:
            case ABNORMALITIES.INTERNAL_LOGISTICS:
            case ABNORMALITIES.LATE_FREIGHT:
            case ABNORMALITIES.NEW_ORDER:
            case ABNORMALITIES.RETURN_FREIGHT:
            case ABNORMALITIES.SHORT_SHIPMENT:
            case ABNORMALITIES.PARTIAL_SHORT_SHIPMENT:
            case ABNORMALITIES.UNABLE_TO_LOCATE:
                return (
                    <Generic
                        id={params.id}
                        manifestBased={manifestBased}
                        abnormalityId={params.abnormalityId}
                        abnormalityType={params.type}
                    />
                );
            case ABNORMALITIES.MISCOLLECTION:
                return (
                    <Miscollection
                        runId={params.id}
                        abnormalityId={params.abnormalityId}
                        abnormalityType={params.type}
                    />
                );
            default:
                return <p>Unknown abnormality type...</p>;
        }
    }
}

export default AbnormalityTypesRouteHandler;
